// Select all quiz blocks
const quizBlocks = document.querySelectorAll('.shopify-section.section-quiz .quiz-block');
if (quizBlocks.length > 0) {
    // Filter the elements to find those with the 'visible' class
    const visibleBlocks = Array.from(quizBlocks).filter(block => block.classList.contains('visible'));
    
    // Get the 'data-index' attribute values of the visible elements
    const dataIndexValues = visibleBlocks.map(block => block.getAttribute('data-index')).join(',');
    
    // Logging the 'data-index' values
    //console.log('quiz-section: init', dataIndexValues);
    updateProgress(dataIndexValues);        



  
    quizBlocks.forEach((quizBlock, index) => {
        // Monitor input changes within each quiz block
        const inputs = quizBlock.querySelectorAll('input');
        const quizBlockInteraction = quizBlock.dataset.question_interaction;
        
        if (inputs.length > 0) {
            inputs.forEach((input) => {
                input.addEventListener('change', () => {
                    if (quizBlockInteraction === 'oninputchange') {
                        if (isAnyInputChecked(quizBlock)) {
                            nextquestion(quizBlock,index);
                        } else {
                            errorFunction();
                        }
                    }
                    if(input.name === 'question_1'){
                      let getImageEl = input.closest('label').querySelector('.answer_img').innerHTML;
                      // console.log('quiz-section: input change', input.name, getImageEl);
                      document.querySelector('.summery-block .block_img').innerHTML = getImageEl;
                    }
                });
            });
        } 
          
        else {
            // If no inputs, directly allow next question                    
            const nextButton = quizBlock.querySelector('.button-wrapper .button.next_quiz');
            if (nextButton) {
                nextButton.addEventListener('click', () => {
                    if(quizBlock.classList.contains('last-block')){
                      submitBlockquestion(quizBlock,index);
                    } else {
                      nextquestion(quizBlock,index);                      
                    }
                });
            }
        }
        /*
        */

        // Monitor button clicks within each quiz block
        const nextButton = quizBlock.querySelector('.button-wrapper .button.next_quiz');
        if (nextButton) {
            nextButton.addEventListener('click', () => {
                if (inputs.length === 0 || isAnyInputChecked(quizBlock)) {
                    nextquestion(quizBlock,index);
                } else {
                    errorFunction();
                }
            });
        }
    });

    // Add listener for ".previous_quiz" button clicks
    const previousButtons = document.querySelectorAll('.previous_quiz');
    previousButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const currentQuizBlock = document.querySelector('.shopify-section.section-quiz .quiz-block.visible');
            if (currentQuizBlock) {
                previewQuiz(currentQuizBlock);
            }
        });
    });

    // Helper function to check if at least one input is checked
    function isAnyInputChecked(quizBlock) {
        const inputs = quizBlock.querySelectorAll('input[type="radio"], input[type="checkbox"]');
        return Array.from(inputs).some((input) => input.checked);
    }

    // Function to handle the next question
    function nextquestion(currentQuizBlock) {
        // console.log('Next question triggered.');
        currentQuizBlock.classList.remove('visible');
        currentQuizBlock.classList.add('hidden');
        const nextQuizBlock = currentQuizBlock.nextElementSibling;
        if (nextQuizBlock && nextQuizBlock.classList.contains('quiz-block')) {
            nextQuizBlock.classList.remove('hidden');
            nextQuizBlock.classList.add('visible');
            updateProgress(currentQuizBlock.dataset.index);
        }
    }
   

    // Function to handle the previous question
    function previewQuiz(currentQuizBlock) {
        // console.log('Previous question triggered.',currentQuizBlock);
        currentQuizBlock.classList.remove('visible');
        currentQuizBlock.classList.add('hidden');
        const previousQuizBlock = currentQuizBlock.previousElementSibling;
        if (previousQuizBlock && previousQuizBlock.classList.contains('quiz-block')) {
            previousQuizBlock.classList.remove('hidden');
            previousQuizBlock.classList.add('visible');
            updateProgress(currentQuizBlock.dataset.index);        
        }
    }

    // Function to handle errors
    function errorFunction() {
        console.log('Error: No input selected.');
    }
    function updateProgress(totalNumberOfSteps) {
      // console.log('totalNumberOfSteps', typeof totalNumberOfSteps);
      
      var progressPercentage =
        (100 / document.querySelectorAll(".shopify-section.section-quiz .quiz-block").length) *
        totalNumberOfSteps;
      document.querySelector(".progress-bar").ariaValueNow = progressPercentage;
      document.querySelector(".progress-bar").style.width =
        progressPercentage + "%";
    };

    function submitBlockquestion(currentQuizBlock) {
      currentQuizBlock.classList.remove('visible');
      currentQuizBlock.classList.add('hidden');
      const nextQuizBlock = currentQuizBlock.nextElementSibling;
      if (nextQuizBlock && nextQuizBlock.classList.contains('quiz-block')) {
          nextQuizBlock.classList.remove('hidden');
          nextQuizBlock.classList.add('visible');
          updateProgress(currentQuizBlock.dataset.index);

          window.firstProgress = new ProgressBar('first', 'Goals');
          window.secondProgress = new ProgressBar('second', 'Custom Fit');
          window.thirdProgress = new ProgressBar('third', 'Selected Essentials');
          
          setTimeout(() => {
            firstProgress.activate();
            firstProgress.startProgress();
          }, 100);
        
      }
      console.log('submitBlock triggered.');
    }
}





  class ProgressBar {
	constructor(id, finalTitle) {
	  this.id = id;
	  this.finalTitle = finalTitle;
	  this.percentage = 0;
	  this.intervalId = null;
	  this.element = document.getElementById(id + '-progress');
	  this.isComplete = false;
	}
	updateProgressBar() {
	  const progressPath = this.element.querySelector('.progress-bar .progress');
	  const dashOffset = 100 - this.percentage;
	  progressPath.style.strokeDashoffset = dashOffset;
	  this.element.querySelector('.progress-percentage').textContent = `${this.percentage}
%`;
	  if (this.percentage >= 100 && !this.isComplete) {
		this.completeProgress();
	  }
	}
	completeProgress() {
	  this.isComplete = true;
	  this.element.querySelector('.progress-title').textContent = this.finalTitle;
	  this.element.querySelector('.progress-percentage').style.display = 'none';
	  this.element.querySelector('.check-icon').style.display = 'block';
	  clearInterval(this.intervalId);
	  const event = new Event('progressComplete');
	  this.element.dispatchEvent(event);
	  if (this.id === 'third') {
		const targetButton = document.querySelector(".quiz-submit-block .generic-button");
		if (targetButton) {
          var interaction = document.querySelector('#submit-block').dataset.question_interaction;
          if(interaction == 'direct'){
            var interactionlink = targetButton.href;
            window.location.href = interactionlink
          } else {
    		  targetButton.classList.remove("hidden");
    		  targetButton.classList.add("");
    		  //targetButton.style.visibility = 'visible';
    		  targetButton.style.transition = 'opacity 0.5s ease-in-out';
    		  // Small delay to ensure the transition takes effect
    		  setTimeout(() => {
    			targetButton.style.opacity = '1';
    		  }, 10);           
          }
          //console.log('interaction',interaction)
		}
	  }
	}
	showPopup() {
	  const popupElement = document.getElementById(this.id + 'Popup');
	  const overlayElement = document.getElementById(this.id + 'PopupOverlay');
	  popupElement.style.display = 'block';
	  overlayElement.style.display = 'block';
	  // Trigger reflow to ensure transition works
	  popupElement.offsetHeight;
	  popupElement.classList.add('visible');
	  overlayElement.classList.add('visible');
	}
	hidePopup() {
	  const popupElement = document.getElementById(this.id + 'Popup');
	  const overlayElement = document.getElementById(this.id + 'PopupOverlay');
	  popupElement.classList.remove('visible');
	  overlayElement.classList.remove('visible');
	  // Wait for transition to complete before hiding
	  setTimeout(() => {
		popupElement.style.display = 'none';
		overlayElement.style.display = 'none';
	  }
				 , 300);
	}
	activate() {
	  this.element.classList.add('visible');
	}
	startProgress() {
	  if (this.intervalId) {
		clearInterval(this.intervalId);
	  }
	  this.intervalId = setInterval(() => {
		if (this.percentage >= 100) {
		  clearInterval(this.intervalId);
		  this.completeProgress();
		  return;
		}
		if (this.percentage === 49) {
		  clearInterval(this.intervalId);
		  this.showPopup();
		  return;
		}
		this.percentage++;
		this.updateProgressBar();
	  }
      // , 5);
      , 75);
	}
	continueProgress() {
	  this.hidePopup();
	  this.percentage++;
	  this.startProgress();
	}
  }
  // Define continueProgress function in global scope
  window.continueProgress = function(which) {
	if (which === 'first') {
	  firstProgress.continueProgress();
	  firstProgress.element.addEventListener('progressComplete', () => {
		setTimeout(() => {
		  secondProgress.activate();
		  secondProgress.startProgress();
		}
				   , 1000);
	  }
											 , {
		once: true }
											);
	}
	else if (which === 'second') {
	  secondProgress.continueProgress();
	  secondProgress.element.addEventListener('progressComplete', () => {
		setTimeout(() => {
		  thirdProgress.activate();
		  thirdProgress.startProgress();
		}
				   , 1000);
	  }
											  , {
		once: true }
											 );
	}
	else {
	  thirdProgress.continueProgress();
	}
  }